import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../styles/loginscreen.css';

const LoginScreen = () => {
  const { loading, signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // Check if already logged in on mount
  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const expiry = localStorage.getItem('tokenExpiry');
    
    if (token && expiry) {
      const now = new Date().getTime();
      const expiryTime = parseInt(expiry, 10);
      
      if (now < expiryTime) {
        navigate('/dashboard/nominations', { replace: true });
      }
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validate credentials
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }

    // Authenticate with Supabase
    const result = await signIn(email, password);

    if (result.success) {
      // Redirect to dashboard
      navigate('/dashboard/nominations', { replace: true });
    } else {
      setError(result.error || 'Invalid email or password');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-screen">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo-wrapper">
            <img 
              src="/assets/images/logo1.png" 
              alt="LegacyStat" 
              className="login-logo" 
            />
          </div>
          <h1 className="login-title">Admin Login</h1>
          <p className="login-subtitle">Sign in to access your dashboard</p>
        </div>
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-input"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label className="form-label">Password</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                className="form-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button 
                type="button"
                className="password-toggle-btn"
                onClick={togglePasswordVisibility}
                tabIndex="-1"
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9.88 9.88a3 3 0 104.24 4.24" />
                    <path d="M10.73 5.08A10.43 10.43 0 0112 5c7 0 10 7 10 7a13.16 13.16 0 01-1.67 2.68" />
                    <path d="M6.61 6.61A13.526 13.526 0 002 12s3 7 10 7a9.74 9.74 0 005.39-1.61" />
                    <line x1="2" y1="2" x2="22" y2="22" />
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                )}
              </button>
            </div>
          </div>
          
          {error && (
            <div className="login-error">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              <span>{error}</span>
            </div>
          )}
          
          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>

          {/* <div className="login-credentials-hint">
            <p>Demo credentials:</p>
            <p><strong>Email:</strong> admin@legacystat.com</p>
            <p><strong>Password:</strong> 12345678</p>
          </div> */}
        </form>
        
        <div className="login-footer">
          <p className="footer-text">© {new Date().getFullYear()} LegacyStat. All rights reserved.</p>
          <p className="footer-version">Admin Panel v1.0</p>
        </div>
      </div>

      {/* Background decorative elements */}
      <div className="login-background-glow"></div>
      <div className="login-background-pattern"></div>
    </div>
  );
};

export default LoginScreen;